export default __webpack_public_path__ + "static/media/paris_skyline2.941875f1.png";